// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.job-shortcuts__item[data-v-73aa6458] {\n  margin-top: 10px;\n}\n.job-shortcuts__item[data-v-73aa6458]:first-child {\n  margin-top: 0;\n}\n@media (max-width: 767px) {\n.job-shortcuts__item[data-v-73aa6458] {\n    margin-top: 0;\n}\n.job-shortcuts__item[data-v-73aa6458]:last-child {\n    margin-bottom: 10px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
